export interface DictionaryEntry {
    type: DictionaryType,
    linkUrl: string,
    linkLabel: string,
}

export enum DictionaryType {
    AcTypes,
    Parameters,
    FuelTypes,
    Currencies,
    UnitConverter,
    FuelPriceIndex,
    FuelFees,
    SapSymbols,
    PapIndex,
    MessageTypesFuelApp
}

export const dictionaries: DictionaryEntry[] = [
    {
        type: DictionaryType.AcTypes,
        linkUrl: '/dictionary/actypes',
        linkLabel: 'A/C TYPES',
    },
    {
        type: DictionaryType.Parameters,
        linkUrl: '/dictionary/parameters',
        linkLabel: 'PARAMETERS',
    },
    {
        type: DictionaryType.FuelTypes,
        linkUrl: '/dictionary/fueltypes',
        linkLabel: 'FUEL TYPES',
    },
    {
        type: DictionaryType.FuelPriceIndex,
        linkUrl: '/dictionary/fuel-price-index',
        linkLabel: 'FUEL PRICE INDEX'
    },
    {
        type: DictionaryType.FuelFees,
        linkUrl: '/dictionary/fuel-fees',
        linkLabel: 'FUEL FEES'
    },
    {
        type: DictionaryType.SapSymbols,
        linkUrl: '/dictionary/sap-symbols',
        linkLabel: 'SAP SYMBOLS'
    },
    {
        type: DictionaryType.Currencies,
        linkUrl: '/dictionary/currencies',
        linkLabel: 'CURRENCY',
    },
    {
        type: DictionaryType.UnitConverter,
        linkUrl: '/dictionary/unit-converter',
        linkLabel: 'UNIT CONVERTER',
    },
    {
        type: DictionaryType.PapIndex,
        linkUrl: '/dictionary/pap-index',
        linkLabel: 'PAP INDEX'
    },
    {
        type: DictionaryType.MessageTypesFuelApp,
        linkUrl: '/dictionary/message-types-fuel-app',
        linkLabel: 'MESSAGE TYPES - FUEL APP'
    }
]
